export const resolution = [
    {
        label: '240p',
        value: '240p',
    },
    {
        label: '360p',
        value: '360p',
    },
    {
        label: '480p',
        value: '480p',
    },
    {
        label: '720p',
        value: '720p',
    },
    {
        label: '1080p',
        value: '1080p',
    },
]

export const listInfoAiConfig = [
    {
        key: 'SWITCH',
        title: "Xóa bản ghi khi tắt dịch vụ",
        value: false,
        id: 'delete_if_off'
    },
    {
        key: 'SWITCH',
        title: "Phóng to màn hình khi phát hiện cảnh báo",
        value: false,
        id: 'is_zoom'
    },
    {
        key: 'SWITCH',
        title: "Bật âm thanh",
        value: false,
        id: 'is_voice'
    },
    // {
    //     key: 'TIME_SAVE',
    //     title: "Thời gian báo đỏ AI (giây)",
    //     value: 10,
    //     id: 'time_alert_event'
    // },
    {
        key: 'TIME_SAVE',
        title: "Thời gian lưu trữ AI (Ngày)",
        value: 14,
        id: 'time_keeping_event_default'
    },
    {
        key: 'TIME_FRAME',
        title: "Khung giờ cho phép",
        value: ["12:00", "23:00"],
        id: 'time_frame'
    },
]

export const listInfoStreamConfig = [
    {
        key: 'SELECT_BOX',
        title: "Chế độ stream",
        value: false,
        id: 'stream_mode_default',
        listChild: [
            {
                label: 'copy',
                value: 'copy'
            },
            {
                label: 'h264',
                value: 'h264'
            },
            {
                label: 'h265',
                value: 'h265'
            },
        ]
    },
    {
        key: 'SELECT_BOX',
        title: "Độ phân giải",
        value: false,
        id: 'stream_quality_default',
        listChild: resolution
    },
    // {
    //     key: 'INPUT',
    //     title: "Độ phân giải desktop",
    //     value: '720p',
    //     id: 'resolution_desktop'
    // },
]

export const listInfoPlaybackConfig = [
    {
        key: 'SELECT_BOX',
        title: "Độ phân giải",
        value: false,
        id: 'record_quality_default',
        listChild: resolution
    },
    {
        key: 'TIME_SAVE',
        title: "Thời gian lưu trữ (Ngày)",
        value: 14,
        id: 'time_keeping_record_default'
    }
]